import { useQuery, useQueries } from '@tanstack/react-query';
import { reviewService } from './index';

export const reviewQueryKeys = {
  all: ['reviews'],
  shop: (shopId) => [...reviewQueryKeys.all, 'shop', shopId],
};

export const useShopReviews = (shopId) =>
  useQuery({
    queryKey: reviewQueryKeys.shop(shopId),
    queryFn: () => reviewService.getShopReviews(shopId),
    enabled: !!shopId,
    staleTime: 2 * 60 * 1000,
  });

/** Fetch reviews for many shops (vendor analytics). */
export const useShopReviewsForShops = (shopIds = []) =>
  useQueries({
    queries: shopIds.map((id) => ({
      queryKey: reviewQueryKeys.shop(id),
      queryFn: () => reviewService.getShopReviews(id),
      enabled: !!id,
      staleTime: 2 * 60 * 1000,
    })),
  });
